module.exports = __webpack_public_path__ + "static/oficina-virtual-logo-a25b808fca442f8a1330e29379480090.png";